import { render } from "./FavoriteTree.vue?vue&type=template&id=53cc1b01&scoped=true"
import script from "./FavoriteTree.vue?vue&type=script&lang=js"
export * from "./FavoriteTree.vue?vue&type=script&lang=js"

import "./FavoriteTree.vue?vue&type=style&index=0&id=53cc1b01&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53cc1b01"],['__file',"src/containerss/FavoriteTree.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53cc1b01"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53cc1b01', __exports__)) {
    api.reload('53cc1b01', __exports__)
  }
  
  module.hot.accept("./FavoriteTree.vue?vue&type=template&id=53cc1b01&scoped=true", () => {
    api.rerender('53cc1b01', render)
  })

}


export default __exports__